<!-- GatePassRightSidebar -->
<template>
  <Sidebar
    v-model:visible="trigger"
    :style="{ width: sidebarwidth }"
    position="right"
  >
    <template #header>
      <div class="d-flex align-items-center w-100">
        <h6 class="w-100 mb-0">
          {{ t("assetManagement.gatepass.gatepass") }}
        </h6>
        <div>
          <i class="pi pi-times" @click="closedetailsrightsidebar()"></i>
        </div>
      </div>
    </template>
    <div class="sidebar-container">
      <!-- Main sidebar content -->
      <div class="sidebar-content main-content">
        <b-container>
          <b-form @submit.prevent="saveGatePassForm">
            <b-row>
              <!-- 1st row -->
              <b-col lg="6" md="6" sm="12" cols="12">
                <div class="field">
                  <CustomDropDown
                    v-model="gatePassForm.Type"
                    :items="ServiceType"
                    @change="CheckServiceType(gatePassForm.Type)"
                    :label="t('assetManagement.gatepass.type')"
                    :rules="{ required: true }"
                    :required-icon="true"
                  />
                </div>
              </b-col>
            </b-row>

            <!-- 2nd row -->
            <b-row>
              <b-col
                lg="4"
                md="4"
                sm="4"
                cols="4"
                v-if="
                  gatePassForm.Type == `${1}` || gatePassForm.Type == 'Service'
                "
              >
                <div class="field">
                  <label>{{ t("assetManagement.gatepass.service") }}</label>
                  <AutoCompleteCustom
                    :rules="{ required: true }"
                    :required-icon="true"
                    :id="t('assetManagement.gatepass.service')"
                    v-model="gatePassForm.ServiceCode"
                    :items="ServiceCodeList"
                    @input="LoadAsset(gatePassForm.ServiceCode)"
                    @item-select="assignServiceId"
                  />
                </div>
              </b-col>

              <b-col
                lg="4"
                md="4"
                sm="4"
                cols="4"
                v-if="
                  gatePassForm.Type == `${2}` || gatePassForm.Type == 'Transfer'
                "
              >
                <div class="field">
                  <CustomDropDown
                    v-model="gatePassForm.FromStoreBranchMapID"
                    :items="StoreDropDown"
                    @select="onFromStoreSelect"
                    :label="t('assetManagement.gatepass.frombranch')"
                    :rules="{ required: true }"
                    :required-icon="true"
                  />
                </div>
              </b-col>

              <b-col
                lg="4"
                md="4"
                sm="4"
                cols="4"
                v-if="
                  gatePassForm.Type == `${2}` || gatePassForm.Type == 'Transfer'
                "
              >
                <div class="field">
                  <CustomDropDown
                    v-model="gatePassForm.ToStoreMapID"
                    :items="StoreDropDown"
                    @select="onToStoreSelect"
                    :label="t('assetManagement.gatepass.tobranch')"
                    :rules="{ required: true }"
                    :required-icon="true"
                  />
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                lg="4"
                md="4"
                sm="4"
                cols="4"
                v-if="
                  gatePassForm.Type == `${1}` || gatePassForm.Type == 'Service'
                "
              >
                <div class="field">
                  <CustomDropDown
                    v-model="gatePassForm.SupplierId"
                    :items="supplierList"
                    disabled
                    :label="t('assetManagement.gatepass.supplier')"
                    :rules="{ required: true }"
                    :required-icon="true"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="4" sm="4" cols="4">
                <div class="field">
                  <TextField
                    v-model="gatePassForm.PersonName"
                    type="text"
                    :label="t('assetManagement.gatepass.personname')"
                    id="personName"
                    name="personname"
                    :rules="{ required: true, alphabet: true }"
                    :required-icon="true"
                  />
                </div>
              </b-col>
              <b-col lg="4" md="4" sm="4" cols="4">
                <div class="field">
                  <TextField
                    v-model="gatePassForm.PhoneNumber"
                    type="text"
                    :label="t('assetManagement.gatepass.phno')"
                    id="phoneNumber"
                    name="phoneNumber"
                    :rules="{ required: true, Phonenumber1: true }"
                  />
                </div>
              </b-col>
            </b-row>

            <!-- 4th row -->
            <b-row>
              <b-col lg="4" md="4" sm="4" cols="4">
                <div class="field">
                  <TextField
                    v-model="gatePassForm.Email"
                    type="text"
                    :label="t('assetManagement.gatepass.email')"
                    id="email"
                    name="email"
                    :rules="{ required: true, email: true }"
                  />
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <div class="card p-3">
                  <div class="field">
                    <label for="fileInput" class="form-label"
                      >Photo Upload</label
                    >
                    <input
                      type="file"
                      name="filesend"
                      id="fileInput"
                      ref="fileInput"
                      class="form-control"
                      @change="onFileSelected"
                      accept="image/*"
                      multiple
                    />
                  </div>

                  <div
                    class="card p-3 d-flex align-items-center justify-content-center position-relative"
                    v-if="selectedImage"
                  >
                    <button
                      type="button"
                      class="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                      style="
                        width: 30px;
                        height: 30px;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        z-index: 10;
                      "
                      @click="removeImage"
                    >
                      <i class="pi pi-times" style="font-size: 14px"></i>
                    </button>
                    <h6 class="mb-3">Preview</h6>
                    <img
                      :src="selectedImage"
                      alt="Preview"
                      class="img-fluid rounded shadow"
                      style="max-height: 400px"
                    />
                  </div>
                </div>
              </b-col>

              <!-- Right column -->
              <b-col cols="12" md="6">
                <div class="d-flex flex-row-reverse h-100 align-items-end">
                  <Footer
                    @cancel="closedetailsrightsidebar"
                    :label="
                      t('assetManagement.maintenancedetails.saveSchedule')
                    "
                    :cancelhide="false"
                    :loading="scheduleLoading"
                  />
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-container>
      </div>
    </div>
  </Sidebar>
  <CreateSuccessully :visible="createpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  watchEffect,
} from "vue";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatepicker from "../../../../../../../components/FormComponents/DatePicker.vue";
import NormalTableview from "../../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import Textarea from "../../../../../../../components/FormComponents/TextArea.vue";
import { useRoute } from "vue-router";
import { useForm } from "vee-validate";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { useToast } from "primevue/usetoast";
import StoreService from "../../../../../Service/StoreService";
import AutoCompleteCustom from "../../../../../../../components/FormComponents/AutoComplete.vue";
import GatePassService from "../../../../../Service/AssetManagement/GatePassService";
import Sidebar from "primevue/sidebar";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
// import Checkbox from 'primevue/checkbox';
// import Toast from 'primevue/toast';
import moment from "moment";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";

import common from "../../../../../Service/CommonService";
import supplierService from "../../../../../Service/SupplierMaster";
export default defineComponent({
  props: {
    trigger: {
      type: Boolean,
      default: true,
    },
    tableId: {
      type: String,
      default: "",
    },
  },
  components: {
    Textarea,
    Footer,
    TextField,
    CustomDropDown,
    CustomDatepicker,
    NormalTableview,
    SkeletonTableLoader,
    AutoCompleteCustom,
    Sidebar,
    Tableview,
    // Checkbox,
    // Toast,
    UpdatedSuccessfully,
    CreateSuccessully,
    AlreadyExist,
  },
  setup(props, { emit }) {
    const toast = useToast();
    const route = useRoute();
    const alreadyexistpop = ref(false);
    const updatepop = ref(false);
    const createpop = ref(false);
    const scheduleLoading = ref(false);
    const maintenanceTypeList = ref([]);
    const technicianList = ref([]);
    const reasonList = ref([]);

    const { t } = useI18n();
    const { handleSubmit, resetForm, validate } = useForm();
    const ServiceCodeList = ref([]);
    const sidebarwidth = ref("55rem");
    let SessionUserData = localStorage.getItem("UsersData");

    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let SessionRolesData = localStorage.getItem("RolesData");
    let SessionStoreId: any = ref();
    SessionStoreId.value = localStorage.getItem("StoreId");
    let roleData;
    if (SessionRolesData !== null) {
      roleData = JSON.parse(SessionRolesData);
    }
    const ParamValues = ref({
      StoreId: Number(route.query.Id ?? 0),
      BranchId: Number(route.query.BranchId ?? 0),
    });
    const selectedImage = ref<string | null>(null);

    const srcpreview = ref<string[]>([]);
    const src = ref<File[]>([]);
    const imagereview = ref(false);
    const closedetailsrightsidebar = () => {
      srcpreview.value = [];
      selectedImage.value = null;
      emit("closedetailsrightsidebar");
      Object.assign(gatePassForm.value, copygatePassForm);
    };

    const ServiceType = ref([
      { name: "Service", value: 1 },
      { name: "Transfer", value: 2 },
    ]);

    const supplierList = ref([]);

    const gatePassForm = ref({
      GatepassID: 0,
      ID: 0,
      ServiceID: 0,
      ServiceCode: "",
      FromStoreBranchMapID: 0,
      ToStoreMapID: 0,
      FromStoreID: 0,
      ToStoreID: 0,
      SupplierId: 0,
      PersonName: "",
      PhoneNumber: "",
      Email: "",
      FileUpload: "",
      Type: "",
      CreatedBy: 0,
      CreatedAt: "",
      Remarks: "",
      Status: 0,
    });
    const copygatePassForm = JSON.parse(JSON.stringify(gatePassForm.value));

    watch(
      () => [props.trigger, props.tableId],
      async ([newval, tableId]) => {
        console.log(newval);
        if (newval) {
          await LoadSupplierList();
        }
        if (tableId != "" && newval) {
          console.log("tableId changed:", tableId);
          await GetGassPassData(tableId);
          await LoadStore();
        }
      }
    );

    const isFormTransferType = computed(
      () => gatePassForm.value.Type === "Transfer"
    );
    const isFormServiceType = computed(
      () => gatePassForm.value.Type === "Service"
    );

    function CheckServiceType(type) {
      if (type == 1) {
        gatePassForm.value.FromStoreBranchMapID = 0;
        gatePassForm.value.ToStoreMapID = 0;
        gatePassForm.value.FromStoreID = 0;
        gatePassForm.value.ToStoreID = 0;
      } else if (type == 2) {
        gatePassForm.value.ServiceID = 0;
        gatePassForm.value.ServiceCode = "";
        LoadStore();
      }
    }
    const StoreDropDown = ref([]);

    async function LoadStore() {
      let result = await StoreService.StoreDropDownListByUserId(
        usersData.UserId,
        usersData.OrganizationId,
        usersData.Admin,
        usersData.BranchId
      );

      StoreDropDown.value = result["result"]
        .filter((x) => x.IsActive == true)
        .map((item) => ({
          Id: item.Id,
          StoreCode: item.Code,
          StoreTypeId: item.StoreTypeId,
          StoreTypeName: item.StoreTypeName,
          StoreBranchMapId: item.StoreBranchMapId,
          BranchId: item.BranchId,
          IsZeroBill: item.IsZeroBill,
          IsCamp: item.IsCamp,
          SiteId: item.SiteId,
          name: item.Name + " - " + item.CurrentBranchName,
          value: item.StoreBranchMapId,
        }));

      StoreDropDown.value.sort((a: any, b: any) => {
        const nameA = typeof a.Name === "string" ? a.Name.toLowerCase() : "";
        const nameB = typeof b.Name === "string" ? b.Name.toLowerCase() : "";
        return nameA.localeCompare(nameB);
      });
    }

    async function LoadSupplierList() {
      try {
        const response = await supplierService.GetSuppliersByStoreId(
          ParamValues.value.StoreId,
          ParamValues.value.BranchId
        );
        if (response && response["result"]) {
          supplierList.value = response["result"]
            .filter((i1) => i1.IsActive == true)
            .map((item: any) => {
              return {
                name: item.Name,
                value: item.Id,
              };
            });
        } else {
          supplierList.value = [];
        }
      } catch (error) {
        console.log(error);
        supplierList.value = [];
      }
    }

    //Load Item Autocomplete
    async function LoadAsset(assetName) {
      debugger;
      try {
        if (assetName.length >= 1) {
          const data_response: any =
            await GatePassService.getServiceAutoCompleteList(
              assetName,
              usersData.HospitalId,
              usersData.BranchId,
              ParamValues.value.StoreId
            );
          console.log(data_response);
          // Check if result exists and is an array
          if (
            data_response &&
            data_response.result &&
            Array.isArray(data_response.result)
          ) {
            ServiceCodeList.value = data_response.result

              // .filter((item) => item.StatusID == 1)
              .map((item) => {
                return {
                  label: item.Code + " | " + item.AssetName,
                  value: item.Id,
                  supplierId: item.SupplierId,
                };
              });
          }
        }
      } catch (error) {
        console.log(error);
        ServiceCodeList.value = [];
      }
    }

    function assignServiceId(data) {
      console.log(data);
      gatePassForm.value.ServiceID = data.value.value;
      // if (data.value.supplierId) {
      //   gatePassForm.value.SupplierId = data.value.supplierId;
      // }
      console.log(supplierList.value);
      const selectedSupplier: any = supplierList.value.find(
        (supplier: any) => supplier.value === data.value.supplierId
      );
      console.log(selectedSupplier);
      if (selectedSupplier) {
        gatePassForm.value.SupplierId = selectedSupplier.value;
        console.log("Supplier found:", selectedSupplier.name);
      } else {
        console.log("Supplier ID not found in supplier list");
      }
    }

    async function GetGassPassData(tableId) {
      try {
        const response = await GatePassService.getData(tableId);

        let resfields: any = response["result"];
        Object.keys(gatePassForm.value).forEach((key) => {
          if (resfields[key]) gatePassForm.value[key] = resfields[key];
          gatePassForm.value.Type = resfields.Type == "Service" ? 1 : 2;
          gatePassForm.value.ServiceCode = resfields.ServiceCode;
          srcpreview.value[0] = response["result"].FileUploadPath;
        });
      } catch (error) {
        maintenanceTypeList.value = [];
      }
    }

    function onFileSelected(event: Event) {
      srcpreview.value = [];
      const target = event.target as HTMLInputElement;
      const files = target.files;

      if (files && files.length <= 5) {
        for (let i = 0; i < files.length; i++) {
          console.log(files[i]);

          src.value.push(files[i]);

          srcpreview.value.push(URL.createObjectURL(files[i]));
          selectedImage.value = srcpreview.value[0];
        }
      } else {
        alert("Select only up to 5 images.");
      }

      imagereview.value = true;
      // uploadFile();
    }
    const getImageFileName = ref();
    async function uploadFile(file: File): Promise<any> {
      try {
        const form = new FormData();
        form.append("file", file);
        const result = await common.fileupload(form, "Image");
        return result;
      } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
      }
    }

    const removeImage = () => {
      // Revoke all object URLs to prevent memory leaks
      srcpreview.value.forEach((preview) => {
        URL.revokeObjectURL(preview);
      });

      // Clear all arrays
      srcpreview.value = [];
      src.value = [];
      selectedImage.value = null;

      // Clear file input
      const fileInput = document.getElementById(
        "fileInput"
      ) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = "";
      }

      // Reset image review flag
      imagereview.value = false;
    };

    const saveGatePassForm = async () => {
      const results = await validate();
      if (results.valid) {
        try {
          let response: any;

          if (src.value.length > 0) {
            // Upload all images and get the last one's filename
            for (let i = 0; i < src.value.length; i++) {
              const result = await uploadFile(src.value[i]);
              getImageFileName.value = result;
            }
          }

          gatePassForm.value.ID =
            props.tableId != "0" ? Number(props.tableId) : 0;
          gatePassForm.value.Type =
            gatePassForm.value.Type == 1 ? "Service" : "Transfer";
          gatePassForm.value.FromStoreBranchMapID = Number(
            gatePassForm.value.FromStoreBranchMapID
          );
          gatePassForm.value.ToStoreMapID = Number(
            gatePassForm.value.ToStoreMapID
          );
          gatePassForm.value.FromStoreID = Number(
            gatePassForm.value.FromStoreID
          );
          gatePassForm.value.ToStoreID = Number(gatePassForm.value.ToStoreID);
          gatePassForm.value.SupplierId = Number(gatePassForm.value.SupplierId);
          gatePassForm.value.PersonName = String(gatePassForm.value.PersonName);
          gatePassForm.value.PhoneNumber = String(
            gatePassForm.value.PhoneNumber
          );
          gatePassForm.value.Email = String(gatePassForm.value.Email);
          gatePassForm.value.FileUpload = getImageFileName.value?.fileName;
          gatePassForm.value.CreatedBy = usersData.UserId;
          gatePassForm.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          gatePassForm.value.Remarks = String(gatePassForm.value.Remarks);
          gatePassForm.value.Status = 1;
          if (gatePassForm.value.ID != 0) {
            const payload = {
              ...gatePassForm.value,
              UpdatedBy: usersData.UserId,
              UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            };

            response = await GatePassService.updateData(payload);
            updatepop.value = true;
          } else {
            console.log(gatePassForm.value);
            response = await GatePassService.createdata(gatePassForm.value);
            createpop.value = true;
          }

          console.log("Saved →", response);
        } catch (error) {
          console.error(error);
        }
      }
    };

    function onFromStoreSelect(selected) {
      console.log("Full selected object:", selected);
      gatePassForm.value.FromStoreID = selected ? selected.Id : 0;
    }
    function onToStoreSelect(selected) {
      console.log("Full selected object:", selected);
      gatePassForm.value.ToStoreID = selected ? selected.Id : 0;
    }

    function closetrigger() {
      closedetailsrightsidebar();
      updatepop.value = false;
      createpop.value = false;
    }

    function alreadyclosetrigger() {
      closedetailsrightsidebar();
      alreadyexistpop.value = false;
    }

    function showImage(data) {
      window.open(data, "_blank");
      selectedImage.value = data;
    }

    return {
      t,
      sidebarwidth,
      scheduleLoading,
      ServiceCodeList,
      maintenanceTypeList,
      technicianList,
      ServiceType,
      closedetailsrightsidebar,
      saveGatePassForm,
      ParamValues,
      LoadAsset,
      gatePassForm,
      closetrigger,
      alreadyclosetrigger,
      alreadyexistpop,
      updatepop,
      reasonList,
      isFormServiceType,
      isFormTransferType,
      LoadSupplierList,
      supplierList,
      StoreDropDown,
      LoadStore,
      CheckServiceType,
      onFileSelected,
      imagereview,
      srcpreview,
      showImage,
      assignServiceId,
      selectedImage,
      GetGassPassData,
      createpop,
      onFromStoreSelect,
      onToStoreSelect,
      removeImage,
    };
  },
});
</script>

<style scoped>
/* Extended sidebar styles */
.sidebar-container {
  display: flex;
  height: 100%;
  /* transition: all 0.3s ease; */
}

.sidebar-container.extended {
  flex-direction: row;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  /* transition: all 0.3s ease; */
}

.main-content.extended {
  flex: 0 0 50%;
  border-right: 1px solid #e9ecef;
  padding-right: 1rem;
}

.extended-content {
  flex: 0 0 50%;
  padding-left: 1rem;
  background-color: #f8f9fa;
  border-left: 1px solid #e9ecef;
  overflow-y: auto;
  animation: slideInRight 0.3s ease;
}

.extended-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 1rem;
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 99;
}
</style>
